// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-no-translate]{translate:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}@media only screen and (max-width: 767px){.gCNMA{margin:0 auto;max-height:100%;width:100%}}@media only screen and (max-width: 767px)and (orientation: landscape){.gCNMA{height:100vh;max-height:initial;overflow-x:auto}}@media only screen and (max-width: 767px){.WDFXt>h2{line-height:1.1em}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": "gCNMA",
	"dialogTitle": "WDFXt"
};
module.exports = ___CSS_LOADER_EXPORT___;
